import { moment } from 'utils';

export default class BasePropertyObject {
  constructor({
    id,
    fidObject,
    fidRight,
    title,
    exemptions,
    taxAuthority,
    propertyType,
    propertyRightType,
    sntsCode,
    sntsType,
    shareNumerator,
    shareDenominator,
    registrationDate,
    registrationEndDate,
    registrationIsStopped,
    personExemption,
    objectExemption,
    accrualHistory,
    skvpzuCode,
    changeToAccept,
    formula = [],
  }) {
    let _originalProperties;
    Object.defineProperty(this, 'originalProperties', {
      enumerable: false,
      get() {
        return _originalProperties;
      },
      set(properties) {
        _originalProperties = properties;
      },
    });

    Object.assign(this, {
      id,
      fidObject,
      fidRight,
      title,
      propertyType,
      propertyRightType,
      sntsCode,
      sntsType,
      personExemption,
      objectExemption,
      accrualHistory,
      registrationIsStopped,
      formula,
      skvpzuCode,
      shareNumerator,
      shareDenominator,
      changeToAccept,
      share: `${shareNumerator}/${shareDenominator}`,

      taxAuthority: {
        code: taxAuthority.code,
        title: taxAuthority.title,
        shortTitle: taxAuthority.shortTitle,
      },

      exemptions: exemptions.map(function (exemption) {
        return {
          startDate: moment.fromServerDatetime(exemption.startDate),
          endDate: exemption.endDate ? moment.fromServerDatetime(exemption.endDate) : null,
        };
      }),

      registrationDate: moment.fromServerDatetime(registrationDate),
      registrationEndDate: registrationEndDate
        ? moment.fromServerDatetime(registrationEndDate)
        : null,
    });
  }

  icon = null;
  iconClass = null;

  static typeTitle = 'Имущество';

  propertyTitles = {
    propertyRightType: 'Вид права',
    registrationDate: 'Дата возникновения права',
    registrationEndDate: 'Дата прекращения права',
    share: 'Доля владения',
    personExemption: 'Льготная категория',
    objectExemption: 'Льгота объекта',
    dataProvider: 'Данные по объекту представлены',
  };

  propertyDisplayValueGetters = {
    share: () => {
      return this.share === 1 ? 1 : `${this.shareNumerator}/${this.shareDenominator}`;
    },
    registrationDate: () => {
      return this.registrationDate.defaultFormat();
    },
    registrationEndDate: () => {
      return this.registrationEndDate && this.registrationEndDate.defaultFormat();
    },
    personExemption: () => this.personExemption.join(', '),
    objectExemption: () => this.objectExemption.map((o) => o.name).join(', '),
  };

  getPropertyInfo = (prop) => {
    const title = this.propertyTitles[prop];
    const getter = this.propertyDisplayValueGetters[prop];

    return {
      propName: prop,
      title,
      value: this[prop],
      displayValue: getter ? getter() : this[prop],
    };
  };

  hasRegistrationEnded = () => {
    return this.registrationIsStopped;
  };

  hasChanges = () => {
    return this.changeToAccept;
  };

  getTypeTitle() {
    return BasePropertyObject.typeTitle;
  }

  getTitle() {
    return this.title;
  }

  getPdfTitle() {
    return this.sntsType;
  }

  getName() {
    return '';
  }

  getCategoryTitle() {
    return this.title;
  }

  getInfo(props) {
    return props.map(this.getPropertyInfo);
  }

  getAccrualHistory() {
    return this.getPropertyInfo('accrualHistory').value;
  }

  isPreferential() {
    if (!this.exemptions || this.registrationIsStopped) {
      return false;
    }

    let hasActiveExemptions = false;

    this.exemptions.forEach(function (exemption) {
      if (hasActiveExemptions) {
        return;
      }

      if (!exemption.endDate || exemption.endDate.isAfter(moment.now())) {
        hasActiveExemptions = true;
      }
    });

    return hasActiveExemptions;
  }

  isRealEstate() {
    return false;
  }

  isTransport() {
    return false;
  }

  isLand() {
    return false;
  }

  isHouse() {
    return false;
  }

  isCar() {
    return false;
  }

  isBoat() {
    return false;
  }

  isPlane() {
    return false;
  }
}
